import { render, staticRenderFns } from "./drugQuery.vue?vue&type=template&id=39603c13&scoped=true&"
import script from "./drugQuery.vue?vue&type=script&lang=js&"
export * from "./drugQuery.vue?vue&type=script&lang=js&"
import style0 from "./drugQuery.vue?vue&type=style&index=0&id=39603c13&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39603c13",
  null
  
)

export default component.exports